import React, { createContext, ReactNode, useState } from "react";

interface IUserDetail {
    private_user_id: number;
    user_first_name: string;
    user_last_name: string;
    user_email: string;
    user_role_id: number;
    user_role_name: string;
}

interface IUserDetailContextType {
    userDetail: IUserDetail | null;
    setUserDetail: (userDetail: IUserDetail | null) => void;
}

const UserDetailContext = createContext<IUserDetailContextType | undefined>(undefined);


interface IUserDetailProviderProps {
    children: ReactNode;
}

const UserDetailProvider = ({ children}: IUserDetailProviderProps) => {

    const [userDetail, setUserDetail] = useState<IUserDetail | null>(null);

    const payload = {
        userDetail: userDetail || null,
        setUserDetail,
    }

    return (
        <UserDetailContext.Provider value={payload}>
            {children}
        </UserDetailContext.Provider>
    );
}

const useUserDetail = () => {
    const context = React.useContext(UserDetailContext);
    if (!context) {
        throw new Error('useUserDetail must be used within a UserDetailProvider');
    }
    return context;
}

export { UserDetailProvider, UserDetailContext, useUserDetail };